import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!user) {
    // /reset-password signs the user out on success, which re-renders
    // this guard with user===null while still on /reset-password. If we
    // captured it as ?redirect=, the subsequent login would bounce the
    // user straight back to the reset page instead of their dashboard.
    // It's never a meaningful post-login destination, so don't capture it.
    const to =
      location.pathname === '/reset-password'
        ? '/login'
        : `/login?redirect=${encodeURIComponent(location.pathname)}`;
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
}
